import { IconButton } from '@genial/components';
import * as Clipboard from 'expo-clipboard';
import React from 'react';

export interface CustomerDuckCopyIconProps {
  valueToCopy: string;
}

export const CustomerDuckCopyIcon: React.FC<CustomerDuckCopyIconProps> = ({ valueToCopy }) => {
  const [success, setSuccess] = React.useState(false);

  const handleCopyValue = () => {
    Clipboard.setStringAsync(valueToCopy).then(() => {
      setSuccess(true);
      setTimeout(() => setSuccess(false), 2000);
    });
  };

  return (
    <IconButton
      p={0}
      icon="Copy"
      iconSize="xxxs"
      testId="copy-button"
      iconColor={success ? 'feedback.success.default' : 'neutral.medium'}
      onPress={handleCopyValue}
    />
  );
};
